
/**
 * 간단 성공 응답
 */
export interface SuccessResponse {
  /** 성공 여부 */
  success: boolean;
}
